import { takeEvery, takeLatest } from 'redux-saga/effects';
import {
  avatarDeleteRequested,
  banUser,
  kickUser,
  kickUserRequested,
  kickUsers,
  kickUsersRequested,
  renameUserRequested,
  sendInvitationEmailsRequested,
  signalingHandLowered,
  signalingHandRaised,
  signalingUserJoined,
  signalingUserKicked,
  signalingUserLeft,
  signalingUserLeftBatch,
  signalingUserRenamed,
  signalingWaitingUserJoined,
  signalingWaitingUserLeft,
  signalingWaitingUserLeftBatch,
  signalingWaitingUsersUpdated,
} from 'features/users/actions';
import { userNameDecrypted } from 'features/e2ee/actions';
import { signalingRoomJoined } from 'features/room/actions';
import { onUserJoinedSaga } from 'features/users/sagas/onUserJoinedSaga';
import { onUserLeftSaga } from 'features/users/sagas/onUserLeftSaga';
import { raiseHandSaga } from 'features/users/sagas/raiseHandSaga';
import { onHandRaisedSaga } from 'features/users/sagas/onHandRaisedSaga';
import { lowerHandSaga } from 'features/users/sagas/lowerHandSaga';
import { onHandLoweredSaga } from 'features/users/sagas/onHandLoweredSaga';
import { handRaiseDismissed, lowerHand, raiseHand } from 'features/users/usersSlice';
import { kickUserSaga } from 'features/users/sagas/kickUserSaga';
import { kickUsersSaga } from 'features/users/sagas/kickUsersSaga';
import { onUserKickedSaga } from 'features/users/sagas/onUserKickedSaga';
import { onWaitingUserJoinedSaga } from 'features/users/sagas/onWaitingUserJoinedSaga';
import { onWaitingUsersUpdatedSaga } from 'features/users/sagas/onWaitingUsersUpdatedSaga';
import { onWaitingUserLeftSaga } from 'features/users/sagas/onWaitingUserLeftSaga';
import { onWaitingUserNameDecryptedSaga } from 'features/users/sagas/onWaitingUserNameDecryptedSaga';
import { onRoomJoinedWaitingUsersSaga } from 'features/users/sagas/onRoomJoinedWaitingUsersSaga';
import { onHandRaiseDismissedSaga } from 'features/users/sagas/onHandRaiseDismissedSaga';
import { onUserLeftBatchedSaga } from 'features/users/sagas/onUserLeftBatchedSaga';
import { onKickUserRequestedSaga } from 'features/users/sagas/onKickUserRequestedSaga';
import { onKickUsersRequestedSaga } from 'features/users/sagas/onKickUsersRequestedSaga';
import { banUserSaga } from 'features/users/sagas/banUserSaga';
import { renameUserSaga } from 'features/users/sagas/renameUserSaga';
import { onUserRenamedSaga } from 'features/users/sagas/onUserRenamedSaga';
import { deleteAvatarSaga } from 'features/users/sagas/deleteAvatarSaga';
import { sendInvitationEmailsSaga } from 'features/users/sagas/sendInvitationEmailsSaga';

export default function* usersWatcher() {
  yield takeEvery(signalingUserJoined, onUserJoinedSaga);
  yield takeEvery(signalingUserLeft, onUserLeftSaga);
  yield takeEvery(signalingUserLeftBatch, onUserLeftBatchedSaga);

  yield takeEvery(raiseHand, raiseHandSaga);
  yield takeEvery(signalingHandRaised, onHandRaisedSaga);
  yield takeEvery(lowerHand, lowerHandSaga);
  yield takeEvery(signalingHandLowered, onHandLoweredSaga);
  yield takeEvery(handRaiseDismissed, onHandRaiseDismissedSaga);

  yield takeLatest(kickUser, kickUserSaga);
  yield takeLatest(kickUsers, kickUsersSaga);
  yield takeLatest(kickUserRequested, onKickUserRequestedSaga);
  yield takeLatest(kickUsersRequested, onKickUsersRequestedSaga);
  yield takeLatest(signalingUserKicked, onUserKickedSaga);

  yield takeLatest(banUser, banUserSaga);

  yield takeEvery(signalingWaitingUserJoined, onWaitingUserJoinedSaga);
  yield takeEvery(signalingWaitingUserLeft, onWaitingUserLeftSaga);
  yield takeEvery(signalingWaitingUserLeftBatch, onWaitingUserLeftSaga);
  yield takeEvery(signalingWaitingUsersUpdated, onWaitingUsersUpdatedSaga);
  yield takeEvery(userNameDecrypted, onWaitingUserNameDecryptedSaga);
  yield takeEvery(signalingRoomJoined, onRoomJoinedWaitingUsersSaga);

  yield takeLatest(renameUserRequested, renameUserSaga);
  yield takeEvery(signalingUserRenamed, onUserRenamedSaga);

  yield takeLatest(sendInvitationEmailsRequested, sendInvitationEmailsSaga);

  yield takeLatest(avatarDeleteRequested, deleteAvatarSaga);
}
